import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const PromotionRoutes: RouteRecordRaw = {
  path: '/promotion',
  name: 'PromotionModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManagePromotionRoute',
      component: () => import('./views/ManagePromotionView.vue'),
      meta: {
        title: 'کمپین های فروش',
      },
    },
    {
      path: 'create',
      name: 'CreatePromotionRoute',
      component: () => import('./views/PromotionUpsertView.vue'),
      meta: {
        title: 'ایجاد کمپین جدید',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:promotionId',
      name: 'EditPromotionRoute',
      component: () => import('./views/PromotionUpsertView.vue'),
      meta: {
        title: 'ویرایش کمپین',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:promotionId',
      name: 'ViewPromotionRoute',
      component: () => import('./views/PromotionUpsertView.vue'),
      meta: {
        title: 'مشاهده کمپین',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.promotion,
  },
}

export default (router: Router) => {
  router.addRoute(PromotionRoutes)
}
